import {Box, Grid} from '@mui/material';
import {useEffect, useState} from 'react';
import {useQuery, useQueryClient} from 'react-query';
import {useDispatch} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import CustomisedButton from '../../../components/button/button';
import ImageSqureCard from '../../../components/card/squreCard/imageSqureCard';
import GoftinoChat from '../../../components/goftino/GoftinoChat';
import CircularCategory from '../../../components/store/circularCategory';
import {SALE_ID} from '../../../config/cacheKey';
import {IMainGetCategoriesResponse} from '../../../models/store.model';
import {
    setUnauthorizedHeaderTitle,
    setUnauthorizedPageData,
} from '../../../redux/headerTitle/unAuthorizedSlice/unAtuthorizedHeaderTitleSlice';
import {IRouteWithState} from '../../../routeWithState/IRouteWithState';
import {GetCategories} from '../../../services/store.service';
import StoreCategoriesSkeleton from './storeCategoriesSkeleton';

export default function StoreCategories({setState}: IRouteWithState) {
    const navigate = useNavigate();
    const [selectedId, setSelectedId] = useState<number>();
    const dispatch = useDispatch();

    // const [categories, setCatgories] = useState<IGetCategoriesResponse[]>()
    const [subCategories, setSubCategories] =
        useState<IMainGetCategoriesResponse[]>();

    const handleSelectedCategory = (id: number) => {
        const selectedCategory = categories?.filter(
            (item: any) => item.id == id
        );
        if (selectedCategory != undefined && selectedCategory != null) {
            setSubCategories(selectedCategory[0].subCategories);
            setSelectedId(selectedCategory[0].id);
        }
    };
    const goToCalculator = () => {
        // navigate('/landing')
        dispatch(setUnauthorizedPageData({page: 'storeCategories'}));
        navigate('/loans/request');

        // dispatch(setUnAuthorizedState({ state: `landingPage` }))
    };

    const {isLoading, data: categories} = useQuery(
        ['GetCategories'],
        () => GetCategories({}),
        {
            staleTime: 1000 * 60 * 15,
            cacheTime: 1000 * 60 * 30,
        }
    );

    useEffect(() => {
        if (categories) {
            setSubCategories(categories[0].subCategories);
            setSelectedId(categories[0].id);
        }
    }, [categories]);

    const subCategoryHandleOnClick = (id: number) => {
        dispatch(setUnauthorizedPageData({page: 'storeCategories', id}));

        navigate(
            window.location.hash.startsWith('#/public')
                ? '/public/store/sellers'
                : '/market/sellers'
        );
    };

    const queryClient = useQueryClient();

    useEffect(() => {
        const path = window.location.pathname; // Gets the full URL

        const saleKey = path.split('/')[2];

        if (
            path.toLocaleLowerCase().includes('/ongoingdetailpurchase/') &&
            saleKey != null &&
            saleKey != ''
        ) {
            queryClient.setQueryData(SALE_ID, saleKey);
            navigate(`/ongoingDetailPurchase/${saleKey}`, {replace: true});
        }

        dispatch(
            setUnauthorizedHeaderTitle({header: 'کمان لند', parentRoute: null})
        );
    }, []);

    if (isLoading) {
        return <StoreCategoriesSkeleton />;
    }

    const windowWidth = window.innerWidth;
    return (
        <>
            {/* <UnauthorizedAppbar /> */}
            <div
                style={{
                    overflowY: 'auto',
                    height: 'calc(100svh - 64px)',
                    marginLeft: '20px',
                    marginRight: '20px',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                }}
            >
                <div>
                    <Grid
                        container
                        style={{
                            paddingTop: '20px',
                            flexWrap: 'nowrap',
                            overflowX: 'auto',
                            gap: '5px',
                        }}
                    >
                        {categories?.map((item: any, index: number) => {
                            return (
                                <CircularCategory
                                    key={index}
                                    data={item}
                                    handleClick={handleSelectedCategory}
                                    isSelected={
                                        item.id == selectedId ? true : false
                                    }
                                ></CircularCategory>
                            );
                        })}
                    </Grid>
                    <Box
                        display="flex"
                        gap={2}
                        flexWrap="wrap"
                        sx={{
                            margin: 'auto',
                            marginTop: '20px',
                            //  paddingInline: { xs: "20px", sm: "20px", md: "0px", lg: "0px", xl: "0px" }
                            flex: 1,
                            paddingInline: '10px',
                            justifyContent: {
                                xs: 'center',
                                sm: 'flex-start',
                                md: 'flex-start',
                            },
                            border: '1.5px solid #D7DBEC',
                            paddingTop: '15px',
                            paddingBottom: '15px',

                            backgroundColor: '#fff',
                            overflowY: 'auto',
                            maxHeight: '400px',
                            borderRadius: '5px',
                            gap: '10px !important',
                        }}
                    >
                        {subCategories?.map((item: any, index: number) => {
                            return (
                                <ImageSqureCard
                                    key={index}
                                    data={item}
                                    onClick={subCategoryHandleOnClick}
                                    aspectRatio="1"
                                    maxHeight={
                                        windowWidth <= 500 ? '50%' : '150px'
                                    }
                                    maxWidth={
                                        windowWidth <= 500 ? '50%' : '150px'
                                    }
                                />
                            );
                        })}
                    </Box>
                </div>
                <Grid
                    item
                    xs={12}
                    sx={{paddingBottom: '20px !important', paddingTop: '10px'}}
                >
                    <CustomisedButton
                        title={'اعتبار خودت رو دریافت کن!'}
                        onClick={goToCalculator}
                        type="submit"
                        disable={false}
                    />
                    <div
                        style={{
                            width: '100%',
                            minHeight: '176px',
                            objectFit: 'cover',
                        }}
                    >
                        <img
                            loading="lazy"
                            src="images/storeCategory.svg"
                            style={{
                                paddingTop: '10px',
                                width: '100%',
                                height: '100%',
                            }}
                        ></img>
                    </div>
                </Grid>
                <GoftinoChat />
            </div>
        </>
    );
}
